export default __webpack_public_path__ + "static/media/ecommercebackend.b6be79f9.jpg";